import React from 'react';
import { formatClassName as _formatClassName } from '../../utils/formatClassName.js';

var ExplainerText = function ExplainerText(_ref) {
  var _ref$align = _ref.align,
      align = _ref$align === void 0 ? 'left' : _ref$align,
      children = _ref.children,
      className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'default' : _ref$size;
  return /*#__PURE__*/React.createElement("div", {
    className: _formatClassName(['explainer-text', "".concat(size, "-explainer-text"), "".concat(align, "-explainer-text"), className])
  }, children);
};

ExplainerText.displayName = "ExplainerText";
export { ExplainerText };